import { useAthosContext } from 'libs/athos/fetchers/provider'
import { useEffect } from 'preact/hooks'
import { useIntersectionObserver } from '@/components/hooks/useIntersectionObserver'

export function useFilterScroll() {
  const { options } = useAthosContext()
  const filters = options.get('filters')
  const sorts = options.get('sort')
  const { setNode: setScrollElement, entry: scrollStartElement } = useIntersectionObserver({ threshold: 0.05 })

  useEffect(() => {
    const target = scrollStartElement?.target
    if (!target) return

    // Measure fresh rather than reusing `scrollStartElement.boundingClientRect`. That
    // rect is a snapshot from whenever intersection last changed, but this effect runs
    // on [filters, sorts], so it was routinely acting on a rect from a previous layout.
    const rect = target.getBoundingClientRect()

    // Only intervene when the top of the results is not on screen.
    const isOffScreen = rect.bottom < 0 || rect.top > window.innerHeight

    if (isOffScreen) {
      const offset = 50
      // `rect.top` is viewport-relative; `scrollTo({ top })` is document-absolute. The
      // previous code passed the viewport value straight through with no `window.scrollY`,
      // so after a filter or sort change the page jumped by roughly the current scroll
      // offset instead of landing on the results.
      window.scrollTo({ top: rect.top + window.scrollY - offset, behavior: 'instant' })
    }
  }, [filters, sorts])

  return { setScrollElement }
}
